import { styled } from '@root/stitches.config';

export const SelectToolsStepWrapper = styled('div', {});
